import React from 'react';
import PropTypes from 'prop-types';
import { Flag } from 'bento-ordering/base/utils/flags';

/**
 * Wrapper component around the Flag component. By default it renders
 * null as the fallback component if the flag returns a falsy value. If
 * the flag is true it will render what's passed in to the render prop.
 * We can also pass in a fallback component
 *
 * Example use of FeatureFlag:
 *  <FeatureFlag
 *    flag={ENABLE_DELIVERY}
 *    renderComponent={<SampleComponent/>}
 *  />
 */
const FeatureFlag = ({ flag, renderComponent, fallbackComponent }) => {
  return (
    <Flag
      name={[flag]}
      render={() => renderComponent}
      fallbackRender={() => fallbackComponent}
    />
  );
};

FeatureFlag.defaultProps = {
  fallbackComponent: null
};

FeatureFlag.propTypes = {
  flag: PropTypes.string.isRequired,
  renderComponent: PropTypes.node.isRequired,
  fallbackComponent: PropTypes.node
};

export default FeatureFlag;
